"use client";

import React from "react";
import "./LanguageSelector.css";
import { useTranslation } from "react-i18next";

export default function LanguageSelector({ className = "" }) {
  const { i18n } = useTranslation();

  const LANGS = [
    { code: "en", label: "English", short: "E" },
    { code: "fr", label: "Français", short: "F" },
    { code: "ar", label: "العربية", short: "ع" },
  ];

  const current = (i18n.language || "en").split("-")[0];
  const currentIdx = LANGS.findIndex((lang) => lang.code === current);
  const safeCurrentIdx = currentIdx >= 0 ? currentIdx : 0;
  const currentLang = LANGS[safeCurrentIdx];

  const nextLang = () => {
    const nextIdx = (safeCurrentIdx + 1) % LANGS.length;
    const nextCode = LANGS[nextIdx].code;

    i18n.changeLanguage(nextCode);
    localStorage.setItem("i18nextLng", nextCode);
    document.documentElement.lang = nextCode;
    document.documentElement.dir = nextCode === "ar" ? "rtl" : "ltr";
  };

  return (
    <div className={`lang-selector ${className}`}>
      <button
        type="button"
        className="lang-toggle-btn"
        onClick={nextLang}
        aria-label={`Change language, current language is ${currentLang.label}`}
        title={currentLang.label}
      >
        <span className="translate-icon" aria-hidden="true">
          <svg
            width="21"
            height="21"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 5h8" />
            <path d="M9 3v2" />
            <path d="M4 11c2.4-.4 5.2-2.1 6.4-5.8" />
            <path d="M6.6 7.4c.7 1.6 2 3 3.9 4.1" />
            <path d="M13 21l4.4-10h1.2L23 21" />
            <path d="M15 17h6" />
          </svg>
        </span>

        <span className="lang-inline-code">{currentLang.short}</span>
      </button>
    </div>
  );
}